import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-gray-400 border-b pb-2" }, " Submit a Sell Order ", -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-sm" }, "Inventory to Sell", -1)
const _hoisted_6 = { class: "flex flex-row mt-5 gap-x-2" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "Miniumim Sell Price", -1)
const _hoisted_9 = { class: "border border-gray-400 rounded flex" }
const _hoisted_10 = { class: "flex-1 text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "¢", -1)
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "# of Rounds", -1)
const _hoisted_14 = { class: "border border-gray-400 rounded flex" }
const _hoisted_15 = { class: "flex-1 text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, "(", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, ")", -1)
const _hoisted_18 = { class: "flex flex-row text-sm" }
const _hoisted_19 = { class: "flex-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "candidates" }, "Skip Confirmation", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/platform-fees",
    class: "text-indigo-600 hover:text-indigo-400 mr-1",
    target: "usae-fees"
  }, "View Fees")
], -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row border-b pb-2 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-gray-400 w-full" }, [
    /*#__PURE__*/_createTextVNode(" Yay! Your Sell Order Has Been"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Submitted to the Trading Desk! ")
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-50 text-sm" }, "You can continue browsing. You'll see a notification popup when your sell order has been settled.", -1)
const _hoisted_25 = { class: "flex flex-row whitespace-nowrap space-x-2 mb-1 mt-5" }
const _hoisted_26 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductMenu = _resolveComponent("ProductMenu")!
  const _directive_autowidth = _resolveDirective("autowidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.roundsOwned && !_ctx.roundsSold)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (!_ctx.productId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_ProductMenu, {
                  onSelected: _ctx.onProductSelected,
                  commodityId: _ctx.commodityId
                }, null, 8, ["onSelected", "commodityId"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([!_ctx.productId && !_ctx.selectedProduct ? 'pointer-events-none opacity-30' : ''])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrCent && _ctx.decrCent(...args))),
                    class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-l"
                  }, " -1¢ "),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "inline border-0 text-right w-16 p-0 my-2 focus:outline-none focus:border-none",
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.milliCents) = $event))
                    }, null, 512), [
                      [_directive_autowidth, { minWidth: `${_ctx.milliCents.toString().length * 10}px`, }],
                      [_vModelText, _ctx.milliCents]
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.incrCent && _ctx.incrCent(...args))),
                    class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-r"
                  }, " +1¢ ")
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decrBox && _ctx.decrBox(...args))),
                    class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-l"
                  }, " -20 "),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "inline border-0 text-right w-16 p-0 my-2 focus:outline-none focus:border-none",
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rounds) = $event))
                    }, null, 512), [
                      [_directive_autowidth, { minWidth: `${_ctx.rounds.toString().length * 10}px` }],
                      [_vModelText, _ctx.rounds]
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.incrBox && _ctx.incrBox(...args))),
                    class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-r"
                  }, " +20 ")
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitOrder())),
              class: "my-4 mt-5 w-full bg-indigo-500 hover:bg-indigo-600 text-white border px-5 py-2 rounded"
            }, [
              _createTextVNode(" Submit Order "),
              _hoisted_16,
              _createTextVNode("$" + _toDisplayString(_ctx.totalAmount()), 1),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  id: "candidates",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.skipConfirmation) = $event)),
                  name: "candidates",
                  type: "checkbox",
                  class: "h-4 w-4 mr-2 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.skipConfirmation]
                ]),
                _hoisted_20
              ]),
              _hoisted_21
            ])
          ], 2)
        ]))
      : (_ctx.roundsSold && !_ctx.skipConfirmation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeOverlay && _ctx.closeOverlay(...args))),
                class: "w-full bg-white text-indigo-500 hover:text-indigo-800 hover:border-indigo-600 border border-slate-300 px-5 py-2 rounded"
              }, " Close Overlay ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, "You have no inventory to sell."))
  ]))
}